export function getAssignmentSeed(userGlobalId: string | undefined | null, questionId: string) {
  return [userGlobalId, questionId].filter(Boolean).join('')
}
